export default __webpack_public_path__ + "static/dock-b563a27b592177d43581cb2f16b135ab.jpg";